// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3CaRf","row":"Node_row__-2eGu","label":"Node_label__3IOZZ","footer":"Node_footer__HmcQa"};